import { render, staticRenderFns } from "./LeaderBoard.vue?vue&type=template&id=0b721993"
import script from "./LeaderBoard.vue?vue&type=script&lang=js"
export * from "./LeaderBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports